import { Flex, chakra, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const MainContent = ({ children, className }: Props) => {
  const bgColor = useColorModeValue('#FBFCFE', '#171717');

  return (
    <Flex
      className={ className }
      flexDir="column"
      flexGrow={ 1 }
      w={{ base: '100%' }}
      minW={ 0 }
      bg={ bgColor }
      overflowX="clip"
    >
      { children }
    </Flex>
  );
};

export default React.memo(chakra(MainContent));
